import React from 'react';
import PropTypes from 'prop-types';
import List from "semantic-ui-react/dist/es/elements/List/List.js";
import { buildKeyFromStrings } from "../../../utils/build-key-from-strings";
import { getFirstFourItems } from "../../../utils/get-first-four-items";
import { Grid } from "../../layout/Grid";
import { GridColumn } from "../../layout/GridColumn";
import { Icon } from "../../elements/Icon";
import { ShowOn } from "../../layout/ShowOn";
export var Component = function Component(_ref) {
  var spaceCharacteristics = _ref.spaceCharacteristics;
  return React.createElement(Grid, {
    columns: 1
  }, React.createElement(GridColumn, {
    width: 12
  }, React.createElement(ShowOn, {
    computer: true,
    parent: List,
    parentProps: {
      horizontal: true
    },
    tablet: true,
    widescreen: true
  }, getFirstFourItems(spaceCharacteristics).map(function (_ref2, index) {
    var iconName = _ref2.iconName,
        text = _ref2.text;
    return React.createElement(List.Item, {
      key: buildKeyFromStrings(text, index)
    }, React.createElement(Icon, {
      labelText: text,
      name: iconName
    }));
  })), React.createElement(ShowOn, {
    mobile: true,
    parent: Grid,
    parentProps: {
      columns: 1
    }
  }, getFirstFourItems(spaceCharacteristics).map(function (_ref3, index) {
    var iconName = _ref3.iconName,
        text = _ref3.text;
    return React.createElement(GridColumn, {
      computer: 3,
      key: buildKeyFromStrings(text, index),
      mobile: 6
    }, React.createElement(Icon, {
      labelText: text,
      name: iconName
    }));
  }))));
};
Component.displayName = 'Characteristics';
Component.defaultProps = {
  spaceCharacteristics: []
};
Component.propTypes = process.env.NODE_ENV !== "production" ? {
  spaceCharacteristics: PropTypes.arrayOf(PropTypes.shape({
    iconName: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired
  }))
} : {};